import {
  IPrMonteCarloDrawImperial,
  IWesleaConfigBatch,
  IWesleaResult,
  IWesleaResultBatch,
} from '@/modules/perRoad/interfaces/monteCarlo';
import { UnitSystem } from '@/interfaces/units';


/**
 * Extract the key horizontal strain values for the target layer.
 *
 * @param draws
 * @param wesleaConfigs
 * @param wesleaResults
 * @param layerNum
 * @param unitSystem
 */
export const getHorizStrainValues = (
  // wesleaResults: IMonteCarloResultsObject[],
  draws: IPrMonteCarloDrawImperial[],
  wesleaConfigs: IWesleaConfigBatch,
  wesleaResults: IWesleaResultBatch,
  layerNum: number,
  unitSystem = UnitSystem.Imperial,
) => {
  const horizStrains: number[] = [];

  console.log('Getting horiz strain values');

  draws.forEach((draw) => {
    const drawResults = wesleaResults[draw.id];
    const wesleaConfig = wesleaConfigs[draw.id];

    const layerBottom_in = draw.layers.filter((layer) => layer.layerNumber === layerNum).map((L) => L.depthOfLayerBottom_in)[0];

    const criticalLocationResults: IWesleaResult[] = [];
    wesleaConfig.criticallocations
      .forEach((critLoc, i) => {
        if (critLoc.l === layerNum && critLoc.z === layerBottom_in && drawResults && drawResults[i]) {
          criticalLocationResults.push(drawResults[i]);
        }
      });

    const strains: number[] = [];
    criticalLocationResults.forEach((result) => {
      const s = result.normal_strain;
      strains.push(...[s.x, s.y]);
    });
    horizStrains.push(Math.min(...strains));
  });
  return horizStrains;
};


// const bins = createHistogramBins(horizontalDeflectionValues);
// console.log('Deflection bins', bins);
// return bins;


/**
 * Filter out the strain below the threshold for traditional ME Design process. Return zeros where threshold isn't met.
 * @param strainValues: array of raw strains values
 * @param threshold_ustrain: the user-input strain threshold, in microstrain. Must be multiplied by 10e-6 to get raw strain thresh.
 */
export const filteredHorizStrain = (strainValues: number[], threshold_ustrain: number) => {
  const threshold = threshold_ustrain * (10 ** (-6));
  return strainValues.map((v) => (v > threshold ? v : 0));
};

export const evaluateTransferFunction = (k1: number, k2: number, strain: number) => {
  return k1 * ((1 / (Math.abs(strain))) ** k2);
};
